import PropTypes from 'prop-types'
import styled, { css } from 'styled-components'
import { Link } from 'react-router'

import IconLink from 'components/Shared/IconLink/Index'

const topElementStyles = css`
  margin-left: 14px;
  &:first-child {
    margin-left: 0;
  }
`

export const StyledTableCellAction = styled(IconLink)`
  &:before {
    height: 16px !important;
    width: 16px !important;
    font-size: 16px !important;
  }

  ${props => !props.to && topElementStyles}

  ${props => props.alwaysShow && css`
    visibility: visible !important;
  `}
`

const StyledLink = styled(Link)`
  ${topElementStyles}
`

const StyledExtLink = styled.a`
  ${topElementStyles}
`


const TableCellAction = ({ iconName, onClick, disabled, hoverable, alwaysShow, tooltip, tooltipId, to, toExternal, target }) => {
  const onClickHandler = (e) => {
    e.stopPropagation()
    onClick?.()
  }
  const params = {
    iconName,
    disabled,
    hoverable,
    alwaysShow,
    'data-tooltip-content': tooltip,
    'data-tooltip-id': tooltipId,
  }

  if (to) {
    return (
      <StyledLink
        to={to}
        onClick={onClickHandler}
        target={target}
      >
        <StyledTableCellAction {...params} />
      </StyledLink>
    )
  } else if (toExternal) {
    return (
      <StyledExtLink
        href={toExternal}
        onClick={onClickHandler}
        target={target}
      >
        <StyledTableCellAction {...params} />
      </StyledExtLink>
    )
  } else {
    return (
      <StyledTableCellAction
        onClick={onClickHandler}
        {...params}
      />
    )
  }
}

TableCellAction.propTypes = {
  iconName: PropTypes.string,
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
  hoverable: PropTypes.bool,
  alwaysShow: PropTypes.bool,
  tooltip: PropTypes.string,
  tooltipId: PropTypes.string,
  to: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.string,
  ]),
  toExternal: PropTypes.string,
  target: PropTypes.string,
}

export default TableCellAction
